<template lang="pug">
.d-flex.flex-row.padded.padded-y
  .col-2.d-flex.flex-column
    v-navigation-drawer(permanent)
      v-list-item
        v-list-item-content
          v-list-item-title.title Pages
          //- v-list-item-subtitle subtext
      v-divider
      v-list(dense, nav)
        v-list-item(
          v-for="item in items",
          v-if="item.render"
          :key="item.title",
          link,
          :to="item.to"
        )
          v-list-item-icon
            v-icon.mr-1 {{ item.icon }}
          v-list-item-content
            v-list-item-title {{ item.title }}
    //- router-link(class="", to="/portal/admin/package") Package
    //- router-link(to="/portal/admin/user") Sub user
    //- router-link(to="/portal/admin/log") Log
  router-view.col-10
</template>

<script>
export default {
  computed: {
    items() {
      return [
        {
          title: "Packages",
          icon: "mdi-view-dashboard",
          to: "/portal/admin/package",
          render: true,
        },
        {
          title: "Admins",
          icon: "mdi-account-lock",
          to: "/portal/admin/admin",
          render: this.$store.getters.isParent ? true : false,
        },
        {
          title: "Users",
          icon: "mdi-account",
          to: "/portal/admin/user",
          render: true
        },
        {
          title: "Logs",
          icon: "mdi-help-box",
          to: "/portal/admin/log",
          render: true,
        },
        {
          title: "Top Up Records",
          icon: "mdi-checkbox-marked-circle-outline",
          to: "/portal/admin/topup",
          render: true,
        },
      ];
    },
  },
};
</script>